import React, { useState } from 'react';
import {
  CCol,
  CRow,
  CInput,
  CSwitch,
  CForm,
  CCard,
  CAlert,
  CFormText,
  CSelect,
} from '@coreui/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { useActions } from '../hooks/useActions';
import { updateUser } from '../actions/usersActions';
import LoaderButton from '../components/LoaderButton';

const validationSchema = Yup.object().shape({
  userId: Yup.string().required('Required'),
  email: Yup.string().email('Invalid email format').required('Required'),
});

function UserForm({ data }) {
  // get required data from store
  const { updatingUser } = useSelector((state) => state.users);

  // bind dispatch to action creators
  const updateUserAction = useActions(updateUser);

  // component state
  const [status, setStatus] = useState(null);

  // initialize form with formik
  const { handleChange, handleSubmit, values, errors, touched } = useFormik({
    initialValues: {
      userId: data && data.userId ? data.userId : '',
      email: data && data.email ? data.email : '',
      goalSettings: data && data.goalSettings ? data.goalSettings : '',
      phone: data && data.phone ? data.phone : '',
      // dailyText: data && data.dailyText ? data.dailyText : false,
      staticGoal: data && data.staticGoal ? data.staticGoal : '',
      reminderText: data && data.reminderText ? data.reminderText : false,
      feedbackText: data && data.feedbackText ? data.feedbackText : false,
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (user) => {
      // if goal settings is adaptive then set staticGoal to 0
      if (user.goalSettings === 'adaptive') user.staticGoal = 0;
      updateUserAction(data.id, user, (status) => {
        // show status message
        setStatus(status);
      });
    },
  });

  return (
    <CCard>
      <CForm className="p-sm-3 p-3" onSubmit={handleSubmit}>
        {/* User Id & Email */}
        <CRow className="p-2">
          <CCol sm="12" md="4" className="xs-margin">
            <label className="text-swtich mx-2">User ID </label>
            <CInput
              name="userId"
              value={values.userId}
              onChange={handleChange}
            />
            {errors.userId && touched.userId && (
              <CFormText color="danger" className="help-block">
                {errors.userId}
              </CFormText>
            )}
          </CCol>
          <CCol sm="12" md="4" className="xs-margin">
            <label className="text-swtich mx-2">Email </label>
            <CInput name="email" value={values.email} onChange={handleChange} />
            {errors.email && touched.email && (
              <CFormText color="danger" className="help-block">
                {errors.email}
              </CFormText>
            )}
          </CCol>
        </CRow>
        {/* Phone Number & Goal Settings */}
        <CRow className="p-2">
          <CCol sm="12" md="4" className="xs-margin">
            <label className="text-swtich mx-2">Phone Number: </label>
            <CInput name="phone" value={values.phone} onChange={handleChange} />
          </CCol>
          <CCol sm="12" md="4" className="xs-margin mt-0">
            <label className="text-swtich mx-2">Goal Setting: </label>
            <CSelect
              name="goalSettings"
              value={values.goalSettings}
              onChange={handleChange}
            >
              <option value="adaptive">Adaptive</option>
              <option value="static">Static</option>
            </CSelect>
          </CCol>
          {values.goalSettings === 'static' && (
            <CCol sm="12" md="4">
              <label className="text-swtich mx-2">Static Goal: </label>
              <CInput
                name="staticGoal"
                value={values.staticGoal}
                onChange={handleChange}
              />
            </CCol>
          )}
        </CRow>
        <CRow className="p-2">
          {/* Daily Texts */}
          {/* <CCol sm="12" md="4">
            <label className="text-swtich mx-2">Daily Texts: </label>
            <CSwitch
              className="pt-2"
              variant="3d"
              color={"primary"}
              name="dailyText"
              value={values.dailyText}
              onChange={handleChange}
              checked={values.dailyText}
            />
          </CCol> */}
          {/* Reminder Texts */}
          <CCol sm="12" md="4">
            <label className="text-swtich mx-2">Reminder Texts: </label>
            <CSwitch
              className="pt-2"
              variant="3d"
              color={'primary'}
              name="reminderText"
              value={values.reminderText}
              onChange={handleChange}
              checked={values.reminderText}
            />
          </CCol>
          {/* Feedback texts */}
          <CCol sm="12" md="4">
            <label className="text-swtich mx-2">Feedback Texts: </label>
            <CSwitch
              className="pt-2"
              variant="3d"
              color={'primary'}
              name="feedbackText"
              value={values.feedbackText}
              onChange={handleChange}
              checked={values.feedbackText}
            />
          </CCol>
        </CRow>
        <CRow className="p-2">
          <CCol>
            <LoaderButton
              title="Update"
              loading={updatingUser}
              onClick={handleSubmit}
              type="submit"
            />
          </CCol>
        </CRow>
        <CRow className="mt-3">
          <CCol className="w-75 width-xs" md={4}>
            {status && (
              <CAlert color={status.type === 'success' ? 'success' : 'danger'}>
                {status.message}
              </CAlert>
            )}
          </CCol>
        </CRow>
      </CForm>
    </CCard>
  );
}

export default UserForm;
